module.exports = __webpack_public_path__ + "img/04.c018e351.png";